import React from "react";
import FirebaseAuthContext from "./FirebaseAuthContext";

export default function useFirebaseAuth() {
  return React.useContext(FirebaseAuthContext);
}
